/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';

import Spinner from '../Spinner';

import Store from './model/ChannelStore';
import TimelineEventTable from './TimelineEventTable';

import { MdRadio, MdTv } from 'react-icons/md';

const TypeToIcon = (type) => {
    switch (type) {
        case 'radio':
            return <MdRadio />;
        case 'tv':
            return <MdTv />;
        default:
            return type;
    }
};

@inject('auth')
@observer
class ChannelDetails extends Component {
    @observable store = Store.fromJS(this.props.auth, []);

    componentDidMount = () => {
        this.fetchData(this.props.match.params.id, this.props.match.params.timelineId);
        // TODO sync asset updates
        // this.assetsStore.syncUpdate();
    };

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            // Id changes
            this.fetchData(nextProps.match.params.id);
        }
    };

    componentWillUnmount = () => {
        // this.assetsStore.unsyncUpdates();
    };

    fetchData = (id, timelineId) => {
        this.store.fetchChannel(id);
        this.store.fetchTimeline(id, timelineId);
    };

    render() {
        const { channel, timeline } = this.store;

        if (!channel || !channel.id || !timeline || !timeline.id) {
            return <Spinner />;
        }

        return (
            <section>
                <h1>
                    {' '}
                    <Link className="" to={`/channels/details/${channel.id}/`}>
                        {TypeToIcon(channel.type)} {channel.name}
                    </Link>{' '}
                    - {timeline.name}
                </h1>

                <div className="row">
                    <div className="col-12">
                        <table className="table table-sm table-responsive table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        <FormattedMessage id="Timelines.Id" defaultMessage="Id" />
                                    </th>
                                    <td>
                                        <code>{timeline.id}</code>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <FormattedMessage
                                            id="Timelines.Layer"
                                            defaultMessage="Layer"
                                        />
                                    </th>
                                    <td>{timeline.layerId}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <FormattedMessage
                                            id="Timelines.Block"
                                            defaultMessage="Block"
                                        />
                                    </th>
                                    <td>{timeline.blockId}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <FormattedMessage
                                            id="Timelines.Name"
                                            defaultMessage="Name"
                                        />
                                    </th>
                                    <td>{timeline.name}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <TimelineEventTable events={timeline.events} />
            </section>
        );
    }
}

ChannelDetails.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default injectIntl(ChannelDetails);
